import {Type} from 'class-transformer';

import {Helper} from '../helpers/helper';
import {LookinChatSDK} from '../lib/lookinChatSDK';

/**
 * Same as Sakura File entity
 *
 * @category Common entities
 * */
export class File {
  __entity?: 'File';

  id?: number;

  url: string;

  type?: FileGroupTypes;
  title?: string;
  color?: string;
  extension?: string;

  @Type(() => Date)
  dateCreated?: Date | string;

  @Type(() => FileThumb)
  thumbnails?: FileThumb[] = [];

  fileUrl?(size: number = null) {
    let url = this.url;
    if (size && this.thumbnails.length) {
      const thumb = this.thumbnails.find(item => item.size === size);
      if (thumb) {
        url = thumb.url;
      }
    }

    return this.getUrl(url);
  }

  downloadUrl?() {
    return this.getDownloadUrl(this.url);
  }

  // @TODO redo for getters
  fileExtension?(): string {
    return this.extension ? this.extension : ((/[.]/.exec(this.url)) ? /[^.]+$/.exec(this.url).pop() : undefined);
  }

  fileName?(): string {
    return this.title ? this.title : ((/[/]/.exec(this.url)) ? /[^/]+$/.exec(this.url).pop() : ((this.url.length) ? this.url : undefined));
  }

  fileType?() {
    if (this.type) {
      return this.type;
    }

    if (Helper.fileExt(['video']).includes(this.fileExtension())) {
      return 'video';
    }

    if (Helper.fileExt(['image']).includes(this.fileExtension())) {
      return 'image';
    }

    return 'doc';
  }

  getUrl ?(url: string) {
    if (url) {

      if (Helper.validURL(url) || Helper.validBlob(url)) {
        return url;
      } else {
        return LookinChatSDK.instance.config.uploadUrl + url.replace(/^\/+/, '');
      }

    } else {
      return null;
    }
  }

  getDownloadUrl ?(url: string) {
    return this.getUrl(url) + '/download';
  }
}

export class FileThumb {
  size: number;
  url: string;
}

export class WorkerFile extends File {
  getUrl ?(url: string) {
    if (url) {

      if (Helper.validURL(url) || Helper.validBlob(url)) {
        return url;
      } else {
        return LookinChatSDK.instance.config.sakuraUploadUrl + url.replace(/^\/+/, '');
      }

    } else {
      return null;
    }
  }
}

export type FileGroupTypes = 'video' | 'image' | 'doc';
